import axios from 'axios';
import { registerVoiceCall, stopVoiceCall } from './voiceApi';
import { getToken, saveToken } from '../utils/authUtils';

export const getBaseUrl = () => {
  console.log(process.env.REACT_APP_ENV);
  switch (process.env.REACT_APP_ENV) {
    case "staging":
      return 'https://staging.qurve.ai/api/';
    case "production":
      return 'https://api.qurve.ai/api/';
    default:
      return 'https://api.qurve.ai/api/';
  }
};

const BASE_URL = getBaseUrl();

const LOGIN_URL = `${BASE_URL}cortex/login/`;
const QUESTION_URL = `${BASE_URL}cortex/ragchat_b/`;
const TOKEN_REFRESH_URL = `${BASE_URL}testing/token_refresh/`;
const GET_UI_CONFIG_URL = `${BASE_URL}cortex/get_demo_client_ui_config/`;
const SAVE_UI_CONFIG_URL = `${BASE_URL}cortex/add_edit_demo_client_ui_config/`;
const GET_USAGE_STATS_URL = `${BASE_URL}cortex/get_usage_stats/`;

const VIEW_KNOWLEDGE_BASE_URL = `${BASE_URL}cortex/view_knowledge_base/`;
const INGEST_URLS_URL = `${BASE_URL}cortex/ingest_urls/`;
const INGEST_FILE_URL = `${BASE_URL}cortex/ingest_uploaded_file/`;
const DELETE_KNOWLEDGE_BASE_URL = `${BASE_URL}cortex/delete_knowledge_base_entries/`;
const CRAWL_BASE_URL_URL = `${BASE_URL}cortex/crawl_base_url/`;
const DOWNLOAD_FILE_URL = `${BASE_URL}cortex/get_s3_pre_signed_url/`;

/**
 * New endpoint constant for upserting session feedback
 */
const UPSERT_SESSION_FEEDBACK_URL = `${BASE_URL}cortex/upsert_session_feedback/`;

// Function to redirect to login page
const redirectToLogin = () => {
  // Clear all tokens from localStorage
  localStorage.removeItem('token');
  localStorage.removeItem('refresh');
  localStorage.removeItem('refreshToken');

  // Redirect to login page
  window.location.href = '/login';
};

export const login = async (username, password) => {
  console.log(LOGIN_URL);

  const formData = new URLSearchParams();
  formData.append("username", username);
  formData.append("password", password);

  const response = await axios.post(LOGIN_URL, formData.toString(), {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });

  return response.data;
};

export const refresh_token = async () => {
  try {
    const refreshToken = localStorage.getItem('refresh') || localStorage.getItem('refreshToken') ||
      sessionStorage.getItem('refresh_token') || sessionStorage.getItem('refreshToken');

    if (!refreshToken) {
      throw new Error('No refresh token found');
    }

    const response = await axios.post(
      TOKEN_REFRESH_URL,
      { refresh: refreshToken }
    );
    return response;
  } catch (error) {
    console.error('Error refreshing token:', error);
    redirectToLogin();
    throw error;
  }
};

export const fetchUsageStats = async () => {
  try {
    const access_token = getToken();
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${access_token}`
    };

    const response = await fetch(GET_USAGE_STATS_URL, {
      method: 'POST',
      headers,
      body: JSON.stringify({})
    });

    if (!response.ok) {
      if (response.status === 401 || response.status === 403) {
        const newToken = await refresh_token();
        saveToken(newToken.data.access);
        console.log(newToken.data.access);

        return fetchUsageStats();
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching usage stats:', error);
    throw error;
  }
};

export const register_call = async (body = {}, retry = true) => {
  const requestBody = typeof body === 'string' ? { originating_domain: body } : { ...body };
  const metadataString = localStorage.getItem('metadata');
  if (metadataString) {
    try {
      const stored = JSON.parse(metadataString);
      const metadata = Array.isArray(stored)
        ? Object.fromEntries(stored.map(item => [item.key, item.value])) : stored;
      requestBody.metadata = { ...metadata, ...requestBody.metadata };
    } catch (error) {
      console.error('Error parsing metadata:', error);
    }
  }
  try {
    return await registerVoiceCall(BASE_URL, { token: getToken() }, requestBody);
  } catch (error) {
    if (retry && [401, 403].includes(error.status)) {
      const refreshed = await refresh_token();
      saveToken(refreshed.data.access);
      return register_call(requestBody, false);
    }
    throw error;
  }
};

export const stop_call = async (callId, retry = true) => {
  try {
    return await stopVoiceCall(BASE_URL, { token: getToken() }, callId);
  } catch (error) {
    if (retry && [401, 403].includes(error.status)) {
      const refreshed = await refresh_token();
      saveToken(refreshed.data.access);
      return stop_call(callId, false);
    }
    throw error;
  }
};

export async function make_question_request({ sessionId, question }) {
  const access_token = getToken();

  function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.substring(0, name.length + 1) === (name + '=')) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }

  const csrftoken = getCookie('csrftoken');

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${access_token}`,
    'Accept': 'application/json',
    'X-CSRFToken': csrftoken || '',
  };

  console.log(headers)
  let metadata = localStorage.getItem("metadata");

  try {
    const requestBody = {
      text: question,
      session_id: sessionId,
      stream: true,
      metadata: metadata ? JSON.parse(metadata) : {}
    };

    const response = await fetch(QUESTION_URL, {
      method: 'POST',
      headers,
      body: JSON.stringify(requestBody),
      credentials: 'include'
    });

    if (!response.ok) {
      if (response.status == 401 || response.status == 403) {
        const newtoken = await refresh_token();
        saveToken(newtoken.data.access)
        console.log(newtoken.data.access)

        return make_question_request({ sessionId, question })
      }

      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export async function fetchSessionHistory(payload = { index: 0, max_results: 50 }) {
  const access_token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${access_token}`,
    'Accept': 'application/json',
  };

  // Use the received payload, with defaults
  const body = JSON.stringify({
    index: payload.index || 0,
    max_results: payload.max_results || 50,
    start_date: payload.start_date || null,
    end_date: payload.end_date || null,
    sort_by: payload.sort_by || 'timestamp',
    order: payload.order || 'DESC',
    q: payload.q || null
  });

  try {
    console.log("Fetching session history with payload:", body);
    const response = await fetch(`${BASE_URL}cortex/session_history/`, {
      method: "POST",
      headers,
      body: body,
    });

    if (!response.ok) {
      if (response.status === 401 || response.status === 403) {
        const newToken = await refresh_token();
        saveToken(newToken.data.access);
        console.log("Token refreshed successfully.");
        // Retry with the new token, passing the original payload
        return fetchSessionHistory(payload);
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching session history:", error);
    throw error;
  }
}

export async function fetch_chat_history(sessionId) {
  const access_token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${access_token}`,
    'Accept': 'application/json',
  };

  try {
    const response = await fetch(`${BASE_URL}cortex/session_chat_history/`, {
      method: "POST",
      headers,
      body: JSON.stringify({ session_id: sessionId })
    });
    if (!response.ok) {
      if (response.status == 401 || response.status == 403) {
        const newtoken = await refresh_token();
        saveToken(newtoken.data.access)
        console.log(newtoken.data.access)

        return fetch_chat_history(sessionId)
      }

      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  }
  catch (error) {
    throw error;
  }
}

export async function fetchCallAudio(sessionId) {
  const access_token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${access_token}`,
    'Accept': 'application/json',
  };

  try {
    const response = await fetch(`${BASE_URL}cortex/session_audio_history/`, {
      method: "POST",
      headers,
      body: JSON.stringify({ session_id: sessionId }),
    });

    if (!response.ok) {
      if (response.status === 401 || response.status === 403) {
        const newToken = await refresh_token();
        saveToken(newToken.data.access);
        console.log(newToken.data.access);

        return fetchCallAudio(sessionId);
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  } catch (error) {
    console.error("Error fetching audio:", error);
    throw error;
  }
}

export async function getUIConfig() {
  try {
    let accessToken = localStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`
    };

    let response = await fetch(GET_UI_CONFIG_URL, {
      method: "POST",
      headers,
      body: JSON.stringify({})
    });

    if (response.status === 401 || response.status === 403) {
      try {
        const newTokenResponse = await refresh_token();
        const newAccessToken = newTokenResponse.data.access;
        localStorage.setItem("token", newAccessToken);
        headers["Authorization"] = `Bearer ${newAccessToken}`;
        response = await fetch(GET_UI_CONFIG_URL, {
          method: "POST",
          headers,
          body: JSON.stringify({})
        });
      } catch (refreshError) {
        redirectToLogin();
        throw refreshError;
      }
    }

    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("No UI configuration loaded:", response.status);
      throw new Error(`Failed to load UI config: ${response.status}`);
    }
  } catch (error) {
    console.error("Error loading config:", error);
    throw error;
  }
}

export async function saveUIConfig({ bgImgUrl, colorPalette }) {
  try {
    const accessToken = localStorage.getItem("token");
    const refreshTokenValue = localStorage.getItem("refreshToken");

    const payload = {
      background_img_url: bgImgUrl,
      color_palette: JSON.stringify(colorPalette),
    };

    let headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`
    };

    let response = await fetch(SAVE_UI_CONFIG_URL, {
      method: "POST",
      headers,
      body: JSON.stringify(payload)
    });

    if ((response.status === 401 || response.status === 403) && refreshTokenValue) {
      try {
        const refreshUrl = `${BASE_URL}testing/token_refresh/`;
        const refreshData = { refresh: refreshTokenValue };
        const refreshResponse = await fetch(refreshUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(refreshData)
        });

        if (refreshResponse.ok) {
          const refreshResult = await refreshResponse.json();
          const newAccessToken = refreshResult.access;
          if (newAccessToken) {
            localStorage.setItem("token", newAccessToken);
            headers.Authorization = `Bearer ${newAccessToken}`;
            response = await fetch(SAVE_UI_CONFIG_URL, {
              method: "POST",
              headers,
              body: JSON.stringify(payload)
            });
          }
        } else {
          // If refresh token request fails, redirect to login
          redirectToLogin();
          return { success: false, message: "Session expired. Please login again." };
        }
      } catch (refreshError) {
        console.error("Error refreshing token:", refreshError);
        redirectToLogin();
        return { success: false, message: "Session expired. Please login again." };
      }
    }

    if (response.ok) {
      const result = await response.json();
      console.log("Config updated:", result);
      return { success: true, message: "Settings saved successfully!" };
    } else {
      console.error("Failed to update config:", response.status, await response.text());
      return { success: false, message: "Failed to save settings" };
    }
  } catch (error) {
    console.error("Error saving config:", error);
    return { success: false, message: "Error saving settings" };
  }
}

export async function update_session_feedback(payload) {
  const access_token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${access_token}`,
    'Accept': 'application/json',
  };

  try {
    const response = await fetch(UPSERT_SESSION_FEEDBACK_URL, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      // try refresh token once on 401/403 then retry
      if (response.status === 401 || response.status === 403) {
        const newToken = await refresh_token();
        saveToken(newToken.data.access);
        // retry once with new token
        return update_session_feedback(payload);
      }
      // otherwise throw
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating session feedback:', error);
    throw error;
  }
}

export const fetchKnowledgeBase = async () => {
  try {
    const accessToken = getToken();
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    };

    const response = await fetch(VIEW_KNOWLEDGE_BASE_URL, {
      method: 'POST',
      headers,
      body: JSON.stringify({})
    });

    if (!response.ok) {
      if (response.status === 401 || response.status === 403) {
        const newToken = await refresh_token();
        saveToken(newToken.data.access);
        return fetchKnowledgeBase();
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching knowledge base:', error);
    throw error;
  }
};

/**
 * Ingest URLs into knowledge base
 */
export const ingestUrls = async (urls) => {
  try {
    const accessToken = getToken();
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    };

    const response = await fetch(INGEST_URLS_URL, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        urls_to_ingest: urls
      })
    });

    if (!response.ok) {
      if (response.status === 401 || response.status === 403) {
        const newToken = await refresh_token();
        saveToken(newToken.data.access);
        return ingestUrls(urls);
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error ingesting URLs:', error);
    throw error;
  }
};

/**
 * Crawl and ingest base URL - NEW FUNCTION
 */
export const crawlBaseUrl = async (baseUrl) => {
  try {
    const accessToken = getToken();
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    };

    const response = await fetch(CRAWL_BASE_URL_URL, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        base_url: baseUrl
      })
    });

    if (!response.ok) {
      if (response.status === 401 || response.status === 403) {
        const newToken = await refresh_token();
        saveToken(newToken.data.access);
        return crawlBaseUrl(baseUrl);
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error crawling base URL:', error);
    throw error;
  }
};

/**
 * Upload file to knowledge base
 */
export const uploadFile = async (file) => {
  try {
    const accessToken = getToken();
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(INGEST_FILE_URL, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`
      },
      body: formData
    });

    if (!response.ok) {
      if (response.status === 401 || response.status === 403) {
        const newToken = await refresh_token();
        saveToken(newToken.data.access);
        return uploadFile(file);
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};

/**
 * Create text file and upload to knowledge base
 */
export const createAndUploadTextFile = async (content, fileName = 'text_content.txt') => {
  try {
    const blob = new Blob([content], { type: 'text/plain' });
    const file = new File([blob], fileName, { type: 'text/plain' });
    return await uploadFile(file);
  } catch (error) {
    console.error('Error creating and uploading text file:', error);
    throw error;
  }
};

/**
 * Delete knowledge base entries
 */
export const deleteKnowledgeBaseEntries = async (urls) => {
  try {
    const accessToken = getToken();
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    };

    const response = await fetch(DELETE_KNOWLEDGE_BASE_URL, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        urls_to_delete: urls
      })
    });

    if (!response.ok) {
      if (response.status === 401 || response.status === 403) {
        const newToken = await refresh_token();
        saveToken(newToken.data.access);
        return deleteKnowledgeBaseEntries(urls);
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error deleting knowledge base entries:', error);
    throw error;
  }
};

/**
 * Download file from knowledge base
 */
export const downloadKnowledgeBaseFile = async (knowledgeBaseId) => {
  try {
    const accessToken = getToken();
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    };

    // Step 1: Get presigned URL from backend
    const res = await fetch(DOWNLOAD_FILE_URL, {
      method: 'POST',
      headers,
      body: JSON.stringify({ source_url: knowledgeBaseId })
    });

    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        const newToken = await refresh_token();
        saveToken(newToken.data.access);
        return downloadKnowledgeBaseFile(knowledgeBaseId);
      }
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    if (!data?.pre_signed_url) {
      throw new Error('Missing presigned URL from backend');
    }

    // Step 2: Open in new tab so the browser downloads directly
    window.open(data.pre_signed_url, '_blank');

    return { status: 'success' };

  } catch (error) {
    console.error('Error downloading file:', error);
    throw error;
  }
};
